import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconContextualStyle0 = cosmosIconCss;

const CosmosIconContextual$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconContextual extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '17f9d0dcd224aa02970c76b42dd29f5c62e654d0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1c7bc9650e8b4fca05a2aa5642e7aecb0a3aa07f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '0dd020a28569e55628a4375458d07863736cfb05', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m9 16.14.35.36a.51.51 0 0 1-.03.74l-2.83 2.35a.3.3 0 0 1-.49-.23V15H3.5a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5H16a.5.5 0 0 1-.5-.5V5.5h-11v8H7a.5.5 0 0 1 .5.5v2.83l.82-.69a.52.52 0 0 1 .68 0Zm8.24-.82 2.28 2.28a.51.51 0 0 1 .04.71l-.35.35a.51.51 0 0 1-.71 0l-2.3-2.3a4 4 0 1 1 1.8-3.95 4 4 0 0 1-.76 2.91Zm-4.212-4.667a2.54 2.54 0 1 0 1.944 4.694 2.54 2.54 0 0 0-1.944-4.694Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconContextualStyle0; }
}, [1, "cosmos-icon-contextual", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-contextual"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-contextual":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconContextual$1);
            }
            break;
    } });
}

const CosmosIconContextual = CosmosIconContextual$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconContextual, defineCustomElement };
